<article data-filterMenuComponent (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
  <h1 mat-dialog-title class="h1 h1--component-title">
    {{ "filter.menu.title" | translate | async }}
  </h1>
  <div mat-dialog-content>
    <p>
      {{ "filter.menu.content.p1" | translate | async }}
    </p>
    <p>
      {{ "filter.menu.content.p2" | translate | async }}
    </p>
    <fieldset class="fieldset">
      <legend>
        {{ "filter.menu.legend" | translate | async }}
      </legend>
      @if (labelList) {
        <section [formGroup]="labelList">
          @if (labels.length) {
            @for (key of object.keys(labelList.controls); track key; let i = $index) {
              <div class="checkboxItemLabelFilterContainer">
                <mat-checkbox attr.aria-label="{{ labelName(key) }}" (change)="syncData()" [formControlName]="key">{{ labelName(key) }}</mat-checkbox>
              </div>
            }
          } @else {
            <p>
              {{ "filter.menu.no.label" | translate | async }}
            </p>
          }
        </section>
      }
    </fieldset>
  </div>
  <div mat-dialog-actions class="flex flex--end-vertical">
    <div class="flex-child">
      <button type="button" class="button button--green-secondary" mat-stroked-button (click)="openManageLabelsDialog()">
        {{ "dialog.action.manage.labels" | translate | async }}
      </button>
      <button type="button" class="button button--green-secondary" mat-stroked-button [disabled]="!labelSelected" (click)="clearAll()">
        {{ "dialog.action.clear.all" | translate | async }}
      </button>
      <button type="button" class="button button--black-primary" mat-stroked-button (click)="trigger.closeMenu()">
        {{ "dialog.action.close" | translate | async }}
      </button>
    </div>
  </div>
</article>
